module.exports = __webpack_public_path__ + "img/dsci0064.30d0cefc.jpg";